
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import axios from 'axios';

import * as config from '../../config';
import logger from '../../utils/logger';

import Spinner from '../../components/shared/Spinner';

import styles from './j.module.scss';

const ShortLinkRedirect = () => {
  const router = useRouter();
  const { salaryCheck, short_link } = router.query;

  useEffect(() => {
    if (config && short_link) {
      const fetchUrl = async () => {
        const hasSalaryCheck = salaryCheck === 'true';
        const url = `${config.PYTHON_API}/api/v1/jobs/short-url/${short_link}`;

        try {
          const { data } = await axios.get(url, {
            params: {
              salary_check: hasSalaryCheck || undefined,
            },
          });

          if (!data.url) {
            throw new Error(`Request to ${url} returned data with no url!`);
          }

          router.push(
            `${data.url}${hasSalaryCheck ? '&salaryCheck=true' : ''}`,
          );
        } catch (error) {
          logger({
            shortLink: short_link,
            error,
            response: error.response,
          });

          router.push('/404');
        }
      };

      fetchUrl();
    }
  }, [router, config, short_link]);

  return (
    <div className={styles.spinner}>
      <Spinner />
    </div>
  );
};

export default ShortLinkRedirect;


    export async function getServerSideProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/j/[short_link]',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  